import { useState, useEffect } from 'react';
import { useStores } from 'hooks';
import {
  formatCurrency,
  getTrimmedString,
} from 'components/project/ClerkScreen/shared/utils/common';

export const useSellerAction = (currentBid) => {
  // FIXME: NEED TO REMOVE THIS STORE FROM HERE AND PASS THE DATA TO THE HOOK (NOT OBSERVING REAL-TIME)
  const {
    BidStore: { auctionProduct, auction },
    MessageStore: {
      sellerAction,
    },
  } = useStores();

  const [sellerMessage, setSellerMessage] = useState(null);
  const [okayToSell, setOkayToSell] = useState(false);
  const [doNotSell, setDoNotSell] = useState(false);

  const auctionLaneIsOpenForBidding = auction?.isOpenForBidding;
  useEffect(() => {
    if (!auctionLaneIsOpenForBidding) {
      setSellerMessage(null);
    }
  }, [auctionLaneIsOpenForBidding]);

  useEffect(() => {
    const actionHasValue = (searchString) => sellerAction.sellerAction?.includes(searchString);

    if (sellerAction && auctionLaneIsOpenForBidding) {
      if (actionHasValue('CANCEL')) {
        setSellerMessage(null);
        return;
      }
      setSellerMessage(sellerAction.sellerActionMessage);
    }
  }, [auctionLaneIsOpenForBidding, sellerAction]);

  useEffect(() => {
    const messageHasValue = (searchString) => sellerMessage && sellerMessage?.includes(searchString);

    setOkayToSell(messageHasValue('OK TO SELL'));
    setDoNotSell(messageHasValue('DO NOT SELL'));
    return () => null;
  }, [sellerMessage]);

  const getProductDetail = (key) => (auctionProduct && auctionProduct[key]
    ? getTrimmedString(auctionProduct[key])
    : '-');

  const getProductDetailCurrencyValue = (key) => {
    const value = getProductDetail(key);
    if (value !== '-') {
      return `$${formatCurrency(value)}`;
    }
    return value;
  };

  const reserve = getProductDetailCurrencyValue('reserve');
  const reserveType = getProductDetail('reserveType');
  const reserveNumber = Number(reserve.replace(/\D/g, ''));

  const getFormattedReserve = () => {
    if (reserveNumber === 0 && reserveType !== 'No Reserve') return 'RESERVE: -';
    if (reserveNumber === 0 && reserveType === 'No Reserve') return 'RESERVE: (No Reserve)';
    if (reserveNumber > 0 && reserveType !== '-') return `RESERVE: ${reserve} (${reserveType})`;
    return `RESERVE: ${reserve} (FIRM)`;
  };

  const formattedReserve = getFormattedReserve()
  const hasNoReserve = ['-', 'No Reserve'].includes(formattedReserve);
  const hasMetReserve = !hasNoReserve && currentBid >= reserveNumber;
  const isTake = sellerMessage?.indexOf('@') > -1;

  return {
    okayToSell, doNotSell, sellerMessage, formattedReserve, sellerAction, isTake, hasNoReserve, hasMetReserve
  };
};

export default useSellerAction;
